import { createContext } from 'react'
import { ContentfulDocument } from 'types/contentful/graphQlApi'
import { ProductWithVariants } from 'types/product'

type ProductContextProps = {
  discount: {
    title: string | undefined
    description: string | undefined
  }
  variantExist: boolean
  hasSizeChart: boolean
  careCopy: ContentfulDocument | null
  tabs: {
    color_categories: string[]
    product_type: string
    tab_title: string
    products: ProductWithVariants[]
  }[]
}

const ProductContext = createContext<ProductContextProps>({
  discount: {
    title: undefined,
    description: undefined
  },
  variantExist: false,
  hasSizeChart: false,
  careCopy: null,
  tabs: []
})

export default ProductContext
